import React, { useState, useEffect, useRef, useCallback } from 'react';
import ErrorMessage from 'src/components/shared/messages/errorMessage';
import Filters from './filters';
import Grid from './grid';
import apiCalls from 'src/api/apiCalls';
import HeaderComponent from 'src/components/header';
import { message } from 'antd';
const ActivityLog = () => {
  const [isExcelExport, setIsExcelExport] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [filterValues, setFilterValues] = useState({ "email": null, 'cardNumber': null, "currency": null, "tradeType": null, "Status": null, "startDate": null, "endDate": null });
  const [currencies, setCurrencies] = useState([]);
  const [tradeLu, setTradeLu] = useState([]);
  const [stateLu, setStateLu] = useState([]);
  const shouldLog = useRef(true);
  const refreshRef = useRef();
  const breadCrumbList = [
    { bname: ' Operations' },
  ]
  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      getCurrencies();
      getTradeTypes();
      getStatusLu();
    }
  }, [])
  const getCurrencies = async () => {
    try {
      const response = await apiCalls.getCardsLookups('CurrencyLu');
      if (response) {
        setCurrencies(response.data?.Currency)
        setErrorMessage(null)
      }
      else {
        setErrorMessage(apiCalls.isErrorDispaly(response))
      }
    }
    catch (error) {
      setErrorMessage(apiCalls.isErrorDispaly(error))
    }
  }
  const getTradeTypes = async () => {
    try {
      const response = await apiCalls.getCardsLookups('TradeTypeLu');
      if (response) {
        setTradeLu(response.data?.TradeType)
        setErrorMessage(null)
      }
      else {
        setErrorMessage(apiCalls.isErrorDispaly(response))
      }
    }
    catch (error) {
      setErrorMessage(apiCalls.isErrorDispaly(error))
    }
  }
  const getStatusLu = async () => {
    try {
      const response = await apiCalls.getCardsLookups('WalletTradeStatusLu');
      if (response) {
        setStateLu(response?.data?.TradeStatus)
        setErrorMessage(null)
      }
      else {
        setErrorMessage(apiCalls.isErrorDispaly(response))
      }
    }
    catch (error) {
      setErrorMessage(apiCalls.isErrorDispaly(error))
    }
  }
  const handleSearch = useCallback((values) => {
    let _dates = values.dateRange ? values.dateRange.map(date => date.format('YYYY-MM-DD')) : null;
    setFilterValues({
      email: values?.email || null,
      cardNumber: values?.cardNumber || null,
      currency: values?.currency || null,
      tradeType: values?.tradeType || null,
      Status: values?.Status || null,
      startDate: _dates ? _dates[0] : null,
      toDate: _dates ? _dates[1] : null
    });
  }, [])

  const handleExcelExport = useCallback(() => {
    setIsExcelExport(true);
    setTimeout(() => {
      setIsExcelExport(false)
    });
    message.destroy();
    message.success({
      content: 'Download Excel Successfully',
      className: 'custom-msg',
      duration: 3
    });
  }, [])

  return (
    <div className=''>
      <HeaderComponent breadCrumbList={breadCrumbList} />
      {errorMessage && <div className="mb-3"><ErrorMessage msg={errorMessage} /></div>}
      <Filters handleExcelExport={handleExcelExport} filterValues={filterValues} currencies={currencies} tradeLu={tradeLu} stateLu={stateLu} filterObj={handleSearch} onloadGrid={refreshRef?.current?.loadGrid} />
      <Grid filterValues={filterValues} isExcelExport={isExcelExport} ref={refreshRef} />
    </div>
  );
}
export default ActivityLog;
